"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignWithSelectionOrBoolean = void 0;
function alignWithSelectionOrBoolean(response, question) {
    if ([
        "MULTI_SELECT",
        "CHECKBOX",
        "DROP_DOWN",
        "RADIO_BUTTONS",
        "RATING",
    ].includes(question.subType) &&
        question.selections &&
        question.selections.length > 0) {
        var match = question.selections.filter(function (s) {
            return s.title.toLowerCase() === response.answer.toLowerCase();
        })[0];
        return __assign(__assign({}, response), { answer: (match === null || match === void 0 ? void 0 : match.title) || "", associatedId: match === null || match === void 0 ? void 0 : match.id, associatedRootId: match === null || match === void 0 ? void 0 : match.rootId });
    }
    else if ("YES_OR_NO" === question.subType) {
        var answer = response.answer.toLowerCase();
        if (answer === "true" || answer === "yes") {
            answer = "true";
        }
        else if (answer === "false" || answer === "no") {
            answer = "false";
        }
        else {
            answer = "";
        }
        return __assign(__assign({}, response), { answer: answer });
    }
    else {
        return response;
    }
}
exports.alignWithSelectionOrBoolean = alignWithSelectionOrBoolean;
//# sourceMappingURL=alignWithSelectionOrBoolean.js.map